import { all } from "redux-saga/effects";
import { watchFetchAppData } from "./appSaga";
import { watchFetchUserDetails } from "./userSaga"
import { watchFetchChallengeQuestions } from "./challengeQuestionsSaga"
import { watchUpdateAccountActivateData, watchCheckAccountActivationStatus, watchActivateUser } from "./accountActivateSaga"
import {watchFetchUserInfo,watchUpdateUserInfo,watchSaveSecurityQuestions} from "./userInfoSaga"
import { watchFetchResetPasswordUserInfo,watchResetPasswordUpdateUserInfo,watchSaveResetPassword} from './resetPasswordUserInfoSaga'
import { watchFetchChangePasswordUserInfo,watchChangePasswordUpdateUserInfo,watchSaveChangePassword} from './changePasswordUserInfoSaga'
import { watchFetchExpiredPasswordUserInfo,watchExpiredPasswordUpdateUserInfo,watchSaveExpiredPassword} from './expiredPasswordUserInfoSaga'

import { watchVerifyEmail } from './verifyEmailSaga'

export default function* rootSaga() {
  yield all([
    watchFetchAppData(),
    watchFetchUserDetails(),
    watchFetchChallengeQuestions(),
    watchUpdateAccountActivateData(),
    watchCheckAccountActivationStatus(),
    watchActivateUser(),
    watchFetchUserInfo(),
    watchUpdateUserInfo(),
    watchSaveSecurityQuestions(),
    watchFetchResetPasswordUserInfo(),
    watchResetPasswordUpdateUserInfo(),
    watchSaveResetPassword(),
    watchFetchChangePasswordUserInfo(),
    watchChangePasswordUpdateUserInfo(),
    watchSaveChangePassword(),

    watchFetchExpiredPasswordUserInfo(),
    watchExpiredPasswordUpdateUserInfo(),
    watchSaveExpiredPassword(),


    watchVerifyEmail()
  ])
}